import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  textareaId: {
    editor: 'textbox',
    default: 'textAreaId',
  },
  value: {
    default: '',
    editor: 'textbox',
  },
  name: {
    default: 'exampleName',
    editor: 'textbox',
  },
  placeholder: {
    default: 'Enter something here...',
    editor: 'textbox',
  },
  cols: {
    editor: 'textbox',
    default: '',
  },
  rows: {
    editor: 'textbox',
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  textareaStyle: {
    default: '{"width": "200px"}',
    editor: 'textbox',
  },
};

const PlaygroundKnobsV3React: Knobs = {
  ...PlaygroundKnobsV3,
  textareaStyle: { ...PlaygroundKnobsV3.textareaStyle, qualifierStart: '{', qualifierEnd: '}' },
};

const SimpleTextarea: Story = {
  title: 'Playground',
  description: 'A simple textarea element with various attributes and valueChanged event',
  coreComponent_v3: {
    html: `<tag3-textarea {{...knobs}}></tag3-textarea>`,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Textarea {{...knobs}} />`,
    knobs: PlaygroundKnobsV3React,
  },
};

const WithValidationAlert: Story = {
  title: 'With validation',
  description: 'A simple textarea element with various attributes',
  coreComponent_v3: {
    html: `<tag3-textarea {{...knobs}}></tag3-textarea>
<tag3-validation-alert type='warning'> <tag3-icon icon="QuestionMark" ></tag3-icon>
Sorry an error has occurred ... </tag3-validation-alert>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3Textarea {{...knobs}} />
      <Tag3ValidationAlert type='warning'> <Tag3Icon icon="QuestionMark" />
      Sorry an error has occurred ... </Tag3ValidationAlert>
    </div>
    `,
    knobs: PlaygroundKnobs,
  },
};

const WithInlineValidationAlert: Story = {
  title: 'With inline validation',
  description: 'A simple textarea element with various attributes',
  coreComponent_v3: {
    html: `<tag3-textarea {{...knobs}}></tag3-textarea>
<tag3-validation-alert-inline type='warning'> <tag3-icon icon="QuestionMark" ></tag3-icon>
Sorry an error has occurred ... </tag3-validation-alert-inline>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3Textarea {{...knobs}} />
      <Tag3ValidationAlertInline type='warning'> <Tag3Icon icon="QuestionMark" />
      Sorry an error has occurred ... </Tag3ValidationAlertInline>
    </div>
    `,
    knobs: PlaygroundKnobs,
  },
};

export const TagTextareaDocs: Component = {
  type: 'component',
  name: 'textarea',
  description: 'Renders an textarea element',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'textareaId',
      description: 'The id of the textarea',
      type: 'string',
    },
    {
      name: 'name',
      description: 'The name of the textarea',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The value of the textarea',
      type: 'string',
    },
    {
      name: 'placeholder',
      description: 'The placeholder of the textarea',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'disabled',
      type: 'boolean',
    },
    {
      name: 'textareaRef',
      description:
        'textarea ref when it is used with React Hook Form. A demo can be found in tag-docs/Forms',
      type: 'any',
    },
    {
      name: 'textareaStyle',
      description: 'JSX style object in JSON to apply to the text',
      type: 'string',
    },
    {
      name: 'rows',
      description: 'textarea rows attribute',
      type: 'number',
    },
    {
      name: 'cols',
      description: 'textarea cols attribute',
      type: 'number',
    },
    {
      name: 'maxLength',
      description: 'maximum number of characters accepted',
      type: 'number',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'textareaValueChange',
      description: 'Event raised when the value changes',
      parameters: [
        {
          name: 'name',
          type: 'string',
          description: 'textarea name',
        },
        {
          name: 'value',
          type: 'string',
          description: 'textarea value',
        },
      ],
    },
    {
      name: 'textareaBlur',
      description: 'Event raised when the textarea loses focus',
      parameters: [
        {
          name: 'name',
          type: 'string',
          description: 'textarea name',
        },
      ],
    },
    {
      name: 'textareaFocus',
      description: 'Event raised when the textarea gains focus',
      parameters: [
        {
          name: 'name',
          type: 'string',
          description: 'textarea name',
        },
      ],
    },
  ],
  methods: [],
  stories: [SimpleTextarea, WithValidationAlert, WithInlineValidationAlert],
};
